'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { formatFileSize } from '@/shared/formatters';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { uploadAndSendNegociacaoAttachment } from '../store/actions';
import { selectAttachmentUploadStatus } from '../store/selectors';
import { resetAttachmentUpload } from '../store/slice';
import { findAcceptedAttachmentType } from '../types/messaging.types';
interface UseAnexoComposerParams {
  conversaId: string | null;
  caseId: string | null;
  phone: string;
  caption: string;
  shouldPauseIa: boolean;
  blocked?: boolean;
  onEnviado: () => void;
}
interface AnexoPendente {
  name: string;
  sizeLabel: string;
  tipo: 'IMAGE' | 'DOCUMENT';
}
interface UseAnexoComposerResult {
  anexo: {
    pending: AnexoPendente | null;
    error: string | null;
    onSelect: (file: File) => void;
    onRemove: () => void;
  };
  isModalAberto: boolean;
  setModalAberto: (aberto: boolean) => void;
  isEnviando: boolean;
  erroEnvio: string | null;
  interceptouEnvio: () => boolean;
  confirmarEnvio: () => void;
  cancelarEnvio: () => void;
}
export const useAnexoComposer = t0 => {
  const $ = _c(42);
  const {
    conversaId,
    caseId,
    phone,
    caption,
    shouldPauseIa,
    blocked: t1,
    onEnviado
  } = t0;
  const blocked = t1 === undefined ? false : t1;
  const dispatch = useAppDispatch();
  const upload = useAppSelector(selectAttachmentUploadStatus);
  const [arquivo, setArquivo] = useState(null);
  const [erroSelecao, setErroSelecao] = useState(null);
  const [isModalAberto, setModalAberto] = useState(false);
  const [conversaDoAnexo, setConversaDoAnexo] = useState(conversaId);
  const [uploadConversaId, setUploadConversaId] = useState(null);
  const conversaIdRef = useRef(conversaId);
  let t2;
  let t3;
  if ($[0] !== conversaId) {
    t2 = () => {
      conversaIdRef.current = conversaId;
    };
    t3 = [conversaId];
    $[0] = conversaId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] !== blocked || $[4] !== dispatch) {
    t4 = () => {
      if (!blocked) {
        return;
      }
      setArquivo(null);
      setErroSelecao(null);
      setModalAberto(false);
      setUploadConversaId(null);
      dispatch(resetAttachmentUpload());
    };
    t5 = [blocked, dispatch];
    $[3] = blocked;
    $[4] = dispatch;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  if (conversaDoAnexo !== conversaId) {
    setConversaDoAnexo(conversaId);
    setArquivo(null);
    setErroSelecao(null);
    setModalAberto(false);
  }
  let t6;
  if ($[7] !== blocked || $[8] !== dispatch) {
    t6 = file => {
      if (blocked) {
        return;
      }
      const regra = findAcceptedAttachmentType(file.type);
      if (!regra) {
        setArquivo(null);
        setErroSelecao("Formato n\xE3o suportado. Aceitos: PDF, JPG, PNG e DOCX.");
        return;
      }
      if (file.size > regra.maxBytes) {
        setArquivo(null);
        setErroSelecao(`Arquivo excede o limite de ${Math.round(regra.maxBytes / 1048576)} MB.`);
        return;
      }
      setErroSelecao(null);
      setArquivo(file);
      dispatch(resetAttachmentUpload());
    };
    $[7] = blocked;
    $[8] = dispatch;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const onSelect = t6;
  let t7;
  if ($[10] !== dispatch) {
    t7 = () => {
      setArquivo(null);
      setErroSelecao(null);
      dispatch(resetAttachmentUpload());
    };
    $[10] = dispatch;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const onRemove = t7;
  let t8;
  if ($[12] !== arquivo || $[13] !== blocked) {
    t8 = () => {
      if (blocked || !arquivo) {
        return false;
      }
      setModalAberto(true);
      return true;
    };
    $[12] = arquivo;
    $[13] = blocked;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const interceptouEnvio = t8;
  let t9;
  if ($[15] !== dispatch) {
    t9 = () => {
      setModalAberto(false);
      dispatch(resetAttachmentUpload());
    };
    $[15] = dispatch;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const cancelarEnvio = t9;
  let t10;
  if ($[17] !== arquivo || $[18] !== blocked || $[19] !== caption || $[20] !== caseId || $[21] !== conversaId || $[22] !== dispatch || $[23] !== onEnviado || $[24] !== phone || $[25] !== shouldPauseIa) {
    t10 = () => {
      if (blocked || !conversaId || !caseId || !arquivo) {
        return;
      }
      const idEnvio = conversaId;
      setUploadConversaId(idEnvio);
      dispatch(uploadAndSendNegociacaoAttachment({
        conversaId: idEnvio,
        caseId,
        phone,
        file: arquivo,
        caption,
        shouldPauseIa
      })).unwrap().then(() => {
        if (conversaIdRef.current !== idEnvio) {
          return;
        }
        setModalAberto(false);
        setArquivo(null);
        setUploadConversaId(null);
        onEnviado();
      }).catch(() => {
        if (conversaIdRef.current !== idEnvio) {
          return;
        }
      });
    };
    $[17] = arquivo;
    $[18] = blocked;
    $[19] = caption;
    $[20] = caseId;
    $[21] = conversaId;
    $[22] = dispatch;
    $[23] = onEnviado;
    $[24] = phone;
    $[25] = shouldPauseIa;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const confirmarEnvio = t10;
  const uploadDestaConversa = uploadConversaId === conversaId;
  let t11;
  if ($[27] !== arquivo) {
    t11 = arquivo ? {
      name: arquivo.name,
      sizeLabel: formatFileSize(arquivo.size),
      tipo: arquivo.type.startsWith("image/") ? "IMAGE" : "DOCUMENT"
    } : null;
    $[27] = arquivo;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== erroSelecao || $[30] !== onRemove || $[31] !== onSelect || $[32] !== t11) {
    t12 = {
      pending: t11,
      error: erroSelecao,
      onSelect,
      onRemove
    };
    $[29] = erroSelecao;
    $[30] = onRemove;
    $[31] = onSelect;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const t13 = uploadDestaConversa && (upload.status === "uploading" || upload.status === "sending");
  const t14 = uploadDestaConversa && upload.status === "error" ? upload.error : null;
  let t15;
  if ($[34] !== cancelarEnvio || $[35] !== confirmarEnvio || $[36] !== interceptouEnvio || $[37] !== isModalAberto || $[38] !== t12 || $[39] !== t13 || $[40] !== t14) {
    t15 = {
      anexo: t12,
      isModalAberto,
      setModalAberto,
      isEnviando: t13,
      erroEnvio: t14,
      interceptouEnvio,
      confirmarEnvio,
      cancelarEnvio
    };
    $[34] = cancelarEnvio;
    $[35] = confirmarEnvio;
    $[36] = interceptouEnvio;
    $[37] = isModalAberto;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
};